import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedMutation } from '@infl-ts/util-make-apollo-decoded';
import { challengeActivityFragment, ChallengeCardActivity } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
export var useSaveForLater = makeDecodedMutation(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation saveForLater($input: SaveForLaterInput!) {\n      saveForLater(input: $input) {\n        ... on SaveForLaterErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n        ... on SaveForLaterResult {\n          challenge {\n            id\n            activities {\n              ...ChallengeActivityFragment\n            }\n          }\n        }\n      }\n    }\n\n    ", "\n  "])), challengeActivityFragment), t.type({
  saveForLater: t.union([t.type({
    __typename: t.literal('SaveForLaterErrors'),
    errors: t.type({
      message: t.string
    })
  }), t.type({
    __typename: t.literal('SaveForLaterResult'),
    challenge: t.type({
      id: t.string,
      activities: nullable(t.array(ChallengeCardActivity))
    })
  })])
}), t.type({
  input: t.type({
    challengeId: t.string
  })
}));